import { tyroLiveMode } from "../firebase/configKeys";

const createTyroInstance = (): void => {
  try {
    // @ts-ignore
    if (window.Tyro && !window.__tyroPreWarmedInstance) {
      // @ts-ignore
      window.__tyroPreWarmedInstance = new window.Tyro({
        liveMode: tyroLiveMode,
      });
    }
  } catch (error) {
    console.error("Failed to pre-warm Tyro instance:", error);
  }
};

export const preWarmTyro = (): void => {
  // @ts-ignore
  if (window.__tyroPreWarmed || window.__tyroPreWarmedInstance) {
    return;
  }

  // @ts-ignore
  window.__tyroPreWarmed = true;

  // @ts-ignore
  if (window.Tyro || document.getElementById("tyro-js-library")) {
    createTyroInstance();
    return;
  }

  const script = document.createElement("script");
  script.id = "tyro-js-library";
  script.src = "https://pay.connect.tyro.com/v1/tyro.js";
  script.crossOrigin = "anonymous";
  script.async = true;
  script.onload = createTyroInstance;
  document.body.appendChild(script);
};
